const BACKEND_LABELS = {
  wsjtx: 'WSJT-X',
  flrig: 'FLRig',
  fldigi: 'fldigi',
  hamlib: 'Hamlib'
};

export function formatRigDetailNote(detail) {
  if (!detail?.frequencyHz) {
    return '';
  }

  const mhz = (Number(detail.frequencyHz) / 1_000_000).toFixed(3);
  const mode = String(detail.rawMode || detail.mode || '').trim();
  if (!mode) {
    return '';
  }

  const backend = detail.backend ? BACKEND_LABELS[detail.backend] || detail.backend : '';
  return backend ? `Rig: ${mhz} MHz ${mode} (${backend})` : `Rig: ${mhz} MHz ${mode}`;
}

export function appendRigDetailToNotes(existingNotes, detail) {
  const rigNote = formatRigDetailNote(detail);
  if (!rigNote) {
    return existingNotes || '';
  }

  const base = String(existingNotes || '').trim();
  if (!base) {
    return rigNote;
  }
  if (base.includes(rigNote)) {
    return base;
  }

  return `${base} | ${rigNote}`;
}

export function rigDetailFromState(rigState) {
  if (!rigState?.frequencyHz) {
    return null;
  }

  return {
    frequencyHz: rigState.frequencyHz,
    rawMode: rigState.rawMode || rigState.mode,
    mode: rigState.mode,
    backend: rigState.backend
  };
}

export function rigDetailFromQso(qso) {
  if (!qso?.frequencyHz) {
    return null;
  }

  return {
    frequencyHz: qso.frequencyHz,
    rawMode: qso.rawMode || qso.mode,
    mode: qso.mode,
    backend: qso.backend
  };
}
